import { connectCustom } from "@client/lib/misc";

import { type RootContainerProps } from "@client/content/types";
import { TargetSelector, combinedSettingsSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type FacebookComponentProps } from "./component";

const makeMapStateToProps = () => {
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    "colorScheme",
    "embedType",
    "includeParent",
    "numberOfPosts",
    "orderBy",
    { name: "facebookUrl", prop: "url" }
  ]);

  return (state: AppState, props: RootContainerProps): FacebookComponentProps => {
    const { includeParent, ...settings } = settingsSelector(state, props);
    return {
      includeParent: includeParent === "true",
      ...settings,
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
